import { CAST, blurbFor } from '@strategy4kids/persona';
import { usePersonaStore } from '../state/persona-store.js';

/**
 * The opponent picker (P3): every character, one tap to choose who plays the robot side. With a
 * single opponent seat the once-per-table rule is trivially satisfied; the table functions in
 * `@strategy4kids/persona` take over for multi-seat games later.
 */
export function PersonaPicker() {
  const personaId = usePersonaStore((s) => s.personaId);
  const setPersona = usePersonaStore((s) => s.setPersona);
  return (
    <div className="w-full rounded-3xl border-2 border-accent/30 bg-cream/95 p-3 shadow-lg lg:p-4" data-testid="persona-picker">
      <h2 className="mb-2 text-xl font-extrabold text-ink">Your opponent</h2>
      <div className="grid grid-cols-4 gap-x-2 gap-y-1 sm:grid-cols-6 lg:grid-cols-12">
        {CAST.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => setPersona(p.id)}
            aria-pressed={personaId === p.id}
            title={blurbFor(p.id, 'en') ?? p.name}
            className={`flex min-w-0 flex-col items-center gap-1 rounded-2xl p-1 ${personaId === p.id ? 'bg-accent/20 ring-2 ring-accent' : 'opacity-80 hover:opacity-100'}`}
            data-testid={`persona-${p.id}`}
          >
            <img src={p.portrait} alt={p.name} className="aspect-square w-full max-w-[5rem] rounded-2xl object-cover" />
            <span className="line-clamp-2 w-full text-center text-[14px] font-bold leading-tight text-ink">{p.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
